import * as React from 'react';

export default function Search({...rest}) {
  return (
    <svg
      {...rest}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="24px/magnifier">
        <g id="magnifier">
          <path
            id="Shape"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M35.38 33.2L45 43.06L43.1 45L33.56 35.22C30.2369 38.43 25.8003 40.229 21.18 40.24C16.2999 40.182 11.6428 38.1876 8.23327 34.6956C4.82379 31.2036 2.94129 26.5001 2.99999 21.62C2.94129 16.7399 4.82379 12.0364 8.23327 8.54442C11.6428 5.05241 16.2999 3.058 21.18 3C26.0653 3.04743 30.7306 5.03785 34.1456 8.5316C37.5605 12.0253 39.444 16.7349 39.38 21.62C39.3801 25.8189 37.9717 29.8964 35.38 33.2ZM21.18 5.76C12.5246 5.86981 5.59108 12.9644 5.67999 21.62C5.59101 30.279 12.5214 37.3793 21.18 37.5C29.8354 37.3793 36.7601 30.2757 36.66 21.62C36.749 12.9721 29.8275 5.88073 21.18 5.76Z"
            fill="#001E50"
          />
        </g>
      </g>
    </svg>
  );
}
